import React from 'react';
import { Input } from 'antd';
import { useIntl } from 'react-intl';

import { FormField } from '../form-field';
import { FormSection } from '../form-section';
import { usePaymentFormValidationRules } from '../../payment-form-validation-context';

import formStyles from '../../styles.module.scss';

export function CertificateInlineSignupFields(): React.ReactElement {
  const intl = useIntl();
  const validationRules = usePaymentFormValidationRules();

  return (
    <FormSection
      hint={intl.formatMessage({ id: 'certificates.payment.accountPasswordHint' })}
      dividerAfter
    >
      <FormField
        name="password"
        label={intl.formatMessage({ id: 'certificates.payment.password' })}
        variant="input"
        validateTrigger="onBlur"
        rules={validationRules.password}
        className={formStyles.formItem}
      >
        <Input.Password
          autoComplete="new-password"
          placeholder={intl.formatMessage({ id: 'certificates.payment.passwordPlaceholder' })}
        />
      </FormField>
      <FormField
        name="confirmPassword"
        label={intl.formatMessage({ id: 'certificates.payment.confirmPassword' })}
        variant="input"
        validateTrigger="onBlur"
        rules={validationRules.confirmPassword}
        className={formStyles.formItem}
      >
        <Input.Password
          autoComplete="new-password"
          placeholder={intl.formatMessage({
            id: 'certificates.payment.confirmPasswordPlaceholder',
          })}
        />
      </FormField>
    </FormSection>
  );
}
